const ListMaxIndent = (maxIndent: number) =>
  function maxIndent(editor: any) {
    editor.model.document.on('change', () => {
      const selectedElement = editor.model.document.selection.getFirstPosition().parent;
      const indentListCommand = editor.commands.get('indentList');

      if (selectedElement.name === 'listItem' && selectedElement.getAttribute('listIndent') >= maxIndent) {
        indentListCommand.forceDisabled();
      } else {
        indentListCommand.clearForceDisabled();
      }
    });
  };

export default ListMaxIndent;
